import CardInformation from './components/CardInformation';

export const FORM_GROUPS = [
    {
        name: 'CardInformation',
        component: CardInformation,
    },
];
